// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing144({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <RandingStyle4
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/144/1.jpg`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/144/bluegif.gif`}
        qTitleColor="#a00404"
        qOptionColor="blue"
        formFieldColor="white"
        benefitInfoPosition="bottom"
        companyName="본원"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
        eventDates={true}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing144;
